module.exports = __webpack_public_path__ + "img/mobib.e1fdf174.svg";